import { Check } from "lucide-react";
import { GESTIONE } from "@/config/site";
import { goToForm } from "@/lib/prefill";

export const GestioneAssistita = () => (
  <section id="gestione-assistita" className="bg-ivory py-20 lg:py-28" data-testid="gestione-section">
    <div className="container-ph grid gap-10 lg:grid-cols-2 lg:gap-16 items-center">
      <div className="reveal">
        <span className="gold-line mb-5" />
        <p className="eyebrow">Gestione assistita</p>
        <h2 className="h-section mt-3">{GESTIONE.title}</h2>
        <p className="mt-5 text-base sm:text-lg text-ink/75 leading-relaxed">{GESTIONE.text}</p>
        <ul className="mt-8 grid gap-x-8 gap-y-2.5 sm:grid-cols-2">
          {GESTIONE.items.map((it) => (
            <li key={it} className="check-item"><Check size={16} className="mt-1 shrink-0 text-bronze" />{it}</li>
          ))}
        </ul>
        <button className="btn-primary mt-9" onClick={() => goToForm(GESTIONE.prefill)} data-testid="gestione-button">{GESTIONE.button}</button>
      </div>
      <div className="reveal reveal-delay-1 relative">
        <img src={GESTIONE.image} alt={GESTIONE.alt} loading="lazy" className="w-full aspect-[4/3] object-cover" />
        <span className="absolute -bottom-3 -left-3 h-full w-full border border-bronze/60 -z-10 hidden sm:block" />
      </div>
    </div>
  </section>
);
